import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, LoadingSpinner, ModalDialog } from 'vetrf-ui';
import { FormContainer } from 'components/FormContainer';
import { useUserDataContext } from 'components/UserDataContext/context';
import { userDataApi } from 'components/UserDataContext/userData.api';
import { PatentHolder } from 'components/UserDataContext/types';
import { SupervisedObjectWrapper } from 'types/types';
import { WorkParamsFields } from './WorkParamsFields';

type WorkParamsDialogProps = {
  onClose: () => void;
};

export const WorkParamsDialog = ({ onClose }: WorkParamsDialogProps) => {
  const { userData, getUserData } = useUserDataContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (data: PatentHolder & SupervisedObjectWrapper) => {
    setLoading(true);
    userDataApi
      .clarification(data)
      .then(() => {
        getUserData?.();
        onClose();
        navigate(0);
      })
      .finally(() => setLoading(false));
  };

  return (
    <FormContainer
      onSubmit={(data) => handleSubmit(data as PatentHolder & SupervisedObjectWrapper)}
    >
      <ModalDialog
        header="Параметры работы в системе"
        headerClass="modal-header no-close-btn"
        onClose={onClose}
        footer={
          <Button
            disabled={loading}
            type="submit"
            color="success"
            iconColor="white"
            iconSize={100}
            size="sm"
            text="Выбрать и продолжить"
          />
        }
      >
        <WorkParamsFields userData={userData} loading={loading} />
        {loading && (
          <Alert messageType="info" className="mb-0">
            <LoadingSpinner color="blue" icon="spinner" spin="spin" text="Подождите..." />
          </Alert>
        )}
      </ModalDialog>
    </FormContainer>
  );
};
